import { render, staticRenderFns } from "./SearchReservations.vue?vue&type=template&id=49fa70fb&"
import script from "./SearchReservations.vue?vue&type=script&lang=js&"
export * from "./SearchReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports